(function () {
    'use strict';

    class openstcExplorerLeafletCtrl{
        constructor($scope, swifRouteService, dataService, swifCartoLeafletService) {
            this.$scope = $scope;
            this.showLeaflet = false;
            this.route = swifRouteService;
            this.data = dataService;
            this.swifCartoLeafletService = swifCartoLeafletService;
        }
        $onInit() {
            if (!this.type) {
                this.type = this.collection.contentType;
            }
            if (!this.filter) {
                this.filter = this.collection.currentFilter;
            }
            var $ctrl = this;
            this.route.check({resources: ['leaflet']}).then(function () {
                $ctrl.showLeaflet = true;
            });
            this.$scope.$watch('$ctrl.collection.currentFilter', function (newV) {
                $ctrl.filter = newV;
            }, true);
            this.$scope.$watch('$ctrl.collection.lastUpdateDateTime', function (newV) {
                $ctrl.updateMarkers();
            });
        }
        $onChanges(changesObj) {
            this.updateMarkers();
        }
        _onMapInitialized(map) {
            this.map = map;
            this.updateMarkers();
            var height = $('.swif-explorer-left').height();
            $(map._container).height(height);
            map.invalidateSize(true);
        }
        updateMarkers(){
            var $ctrl = this;
            var service = $ctrl.swifCartoLeafletService;
            if (!this.showLeaflet || !(this.type && this.filter)) {
                return;
            }
            var filter = angular.copy(this.filter);
            filter.limit = 0;
            filter.fields = ['geo_point', 'state', 'name', 'site1','swif_id'];

            this.data.addFilter(filter, '|');
            this.data.addFilter(filter, 'site1.geo_point', '!=', false);
            this.data.addFilter(filter, 'geo_point', '!=', false);
            function getMarker(request) {
                var icon = service.getIconFromSite(request);
                var marker = service.getMarkerFromPoint(request.geo_point, {icon: icon});
                var $scope = $ctrl.$scope.$new();
                $scope.collection = $ctrl.collection;
                var linkLabel;
                switch ($ctrl.collection.contentType) {
                    case 'intervention_request':
                        linkLabel = 'Voir la demande';
                        break;
                    case 'intervention':
                        linkLabel = 'Voir l\'intervention';
                        break;
                    case 'task':
                        linkLabel = 'Voir la tâche';
                        break;
                    default:
                        break;
                }
                var footer = `<a class="btn btn-link"
                    ng-click="collection.setCurrent(proxy.id)">
                    ${linkLabel}
                </a>`;
                var html = service.getPanelHTML(request, $scope, {footer: footer});
                marker.bindPopup(html);
                return marker;
            }
            function getSites(data) {
                return service.getSitesWithGeoPoint(data.records)
                .then(function (sites) {
                    data.sites = sites;
                    return data;
                });
            }
            function addMarkers(data) {
                service.removeLayerFromMap($ctrl.layer, $ctrl.map);
                var geoPointBySiteId = {};
                data.sites.forEach(function (site) {
                    geoPointBySiteId[site.id] = site.geo_point;
                });
                var markers = [];
                data.records.forEach(function (request) {
                    if (!request.geo_point && request.site1) {
                        request.geo_point = geoPointBySiteId[request.site1[0]];
                    }
                    var marker = getMarker(request);
                    if (marker) {
                        markers.push(marker);
                    }
                });
                if ($ctrl.map && markers.length > 0) {
                    var layer = L.featureGroup(markers);
                    $ctrl.layer = L.markerClusterGroup();
                    $ctrl.layer.options.spiderfyOnMaxZoom = false;
                    $ctrl.layer.options.disableClusteringAtZoom= 20;
                    $ctrl.layer.addLayer(layer);
                    $ctrl.layer.addTo($ctrl.map);
                    $ctrl.map.fitBounds($ctrl.layer.getBounds());
                }
                if (markers.length === 0) {
                    // when we don't have any markers, we set the view on the default geolocation
                    service.setDefaultCenterView($ctrl.map);
                }
            }
            if (typeof filter.offset !== 'undefined') {
                filter.offset = 0;
            }
            this.data.searchRead(this.type, filter)
            .then(getSites).then(addMarkers);
        }
    }
    openstcExplorerLeafletCtrl.$inject = ['$scope', 'swifRouteService', 'dataService', 'swifCartoLeafletService'];


    angular.module('swif.carto')

    .component('openstcExplorerLeaflet', {
        template: `<div ng-if="$ctrl.showLeaflet" class="widemap">
            <swif-leaflet on-map-initialized="$ctrl._onMapInitialized(map)">
            </swif-leaflet>
        </div>`,
        controller: openstcExplorerLeafletCtrl,
        bindings: {
            collection: '<'
        }
    });


})();
